/** A new Re-Printing Packing Slip. Nothing is written, and no number spent, until the first Post. */
import { createFileRoute, redirect } from "@tanstack/react-router";
import { FormPageSkeleton } from "@/components/app/skeletons";
import { useAuth } from "@/features/auth/store";
import { useFacilities } from "@/features/auth/use-facilities";
import { REPRINT_ORDER_FORM } from "@/features/packaging/api";
import { WorkOrderPage } from "@/features/packaging/components/work-order-page";

export const Route = createFileRoute("/_app/packaging/reprint-slip/new")({
  beforeLoad: () => {
    if (!useAuth.getState().canCreateForm(REPRINT_ORDER_FORM))
      throw redirect({ to: "/packaging/reprint-slip" });
  },
  component: Page,
});

function Page() {
  const { selected, ready } = useFacilities();
  if (!ready) return <FormPageSkeleton />;
  return (
    <WorkOrderPage
      kind="reprint"
      order={null}
      facilityId={selected?.id}
      plantName={selected ? `${selected.name} (${selected.plantCode})` : null}
    />
  );
}
